var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.853414 5.73866C0.695038 5.58077 0.694646 5.32438 0.852539 5.166C1.01043 5.00763 1.26682 5.00723 1.4252 5.16513L4.47863 8.20924C4.63701 8.36713 4.6374 8.62352 4.47951 8.7819C4.32161 8.94027 4.06523 8.94067 3.90685 8.78277L0.853414 5.73866ZM14.7416 1.14243C14.8997 0.984294 14.8997 0.727907 14.7416 0.569772C14.5834 0.411638 14.327 0.411638 14.1689 0.569772L5.25362 9.48506C5.09549 9.64319 5.09549 9.89958 5.25362 10.0577C5.41176 10.2158 5.66814 10.2158 5.82628 10.0577L14.7416 1.14243Z","fill":"currentColor"}));
}

Checkmark.defaultProps = {"width":"15","height":"11","viewBox":"0 0 15 11","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
